import { render } from "./index.vue?vue&type=template&id=65b511c5&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=65b511c5&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b511c5"]])

export default __exports__